import category from './filters/category';

const filters = {
	category,
};

/**
 * Combines the fetchedFilters with the current values for the modal
 *
 * @param {array} filters
 * @param {array} values
 * @return {array}
 */
const getFiltersForModal = (filters, values) => (
	filters.map(filter => {
		const foundValues = values.filter(filterValue => filterValue.name === filter.name);

		return {
			...filter,
			value: foundValues.length === 1 ? foundValues[0].value : null
		};
	})
);

const getActiveFilters = (filters, values) => (

	filters.filter(filter => {

		const filtersWithSetValues = values.filter(filterValue => filterValue.value !== null);
		return filtersWithSetValues.some( setFilter => setFilter.name === filter.name );

	})

);

const getUpdatedValue = (name, changedValue, value) => filters[name].getUpdatedValue(changedValue, value);
const isMatch = (name, newsitem, value) => !filters[name].isSet(value) || filters[name].isMatch(newsitem, value);
const isSet = (name, value) => filters[name].isSet(value);

/**
 * @param {Array} newsitems
 * @param {Array} filterState
 * @param {String} filterName
 * @param {*} filterValue
 * @returns {number} integer
 */
const getMatchCountForFilterValue = (newsitems, filterState, filterName, filterValue) => (
	newsitems.filter(newsitem => filterState.filter(filter => isMatch(filter.name, newsitem, filter.name === filterName ? filterValue : filter.value)).length === filterState.length).length
);

/**
 * Checks for min and max value separately and returns lowest value
 *
 * @param {Array} newsitems
 * @param {Array} filterState
 * @param {String} filterName
 * @param {*} filterValue
 * @returns {number} integer
 */
const getMatchCountForRangeFilterValue = (newsitems, filterState, filterName, filterValue) => Math.min(getMatchCountForFilterValue(newsitems, filterState, filterName, { max: filterValue }), getMatchCountForFilterValue(newsitems, filterState, filterName, { min: filterValue }));

export {
	getUpdatedValue,
	getFiltersForModal,
	getActiveFilters,
	isMatch,
	isSet,
	getMatchCountForFilterValue,
	getMatchCountForRangeFilterValue
};
